import comp from "./DragNDropSortableList";
export default comp;
